import React, { useState } from 'react';
import { useParams } from 'react-router';
import { Card, CardBody, Col, Container } from 'reactstrap';
import PublicHeaderComponent from '../../common/PublicHeaderComponent';
import { CheckCircle, Copy, Check } from 'react-feather';

const PaymentSuccessPage = () => {
  const { templeUuid, razorpay_order_id } = useParams();
  const [copied, setCopied] = useState(false);
  const [isDone, setIsDone] = useState(false);

  const handleCopy = () => {
    if (razorpay_order_id) {
      navigator.clipboard.writeText(razorpay_order_id);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleDone = () => {
    setIsDone(true);
    // If opened in a separate tab or popup, close it; otherwise show close instruction
    try {
      window.close();
    } catch (e) {
      // Ignored if browser prevents window.close
    }
  };

  return (
    <div className="panel" style={{ minHeight: '100vh', background: '#f5f7fb' }}>
      <div className="donarbackGround" style={{ minHeight: '100vh' }}>
        <PublicHeaderComponent secondTitle="blue" therdTitle="black" templeUuid={templeUuid} />

        <Container fluid={true} className="py-4">
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 'calc(100vh - 160px)' }}>
            <Col sm="12" md="8" lg="6" xl="5">
              <Card className="shadow-lg border-0 rounded-4 overflow-hidden" style={{ background: '#ffffff' }}>
                <div
                  style={{
                    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                    padding: '35px 20px',
                    textAlign: 'center',
                    color: '#ffffff'
                  }}
                >
                  <div
                    style={{
                      width: '76px',
                      height: '76px',
                      borderRadius: '50%',
                      background: 'rgba(255, 255, 255, 0.2)',
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '16px',
                      boxShadow: '0 8px 16px rgba(0,0,0,0.1)'
                    }}
                  >
                    <CheckCircle size={44} color="#ffffff" strokeWidth={2.5} />
                  </div>
                  <h3 className="fw-bold mb-1" style={{ fontSize: '24px' }}>
                    Booking Confirmed!
                  </h3>
                  <p className="mb-0 text-white-50" style={{ fontSize: '15px' }}>
                    Your payment was successful and room reservation is registered
                  </p>
                </div>

                <CardBody className="p-4">
                  {razorpay_order_id && razorpay_order_id !== 'undefined' && (
                    <div
                      className="p-3 mb-3 rounded-3"
                      style={{
                        background: '#f0fdf4',
                        border: '1px solid #bbf7d0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: '10px'
                      }}
                    >
                      <div>
                        <div className="text-muted small fw-semibold">ORDER / REFERENCE ID</div>
                        <div className="fw-bold text-dark font-monospace" style={{ fontSize: '15px', wordBreak: 'break-all' }}>
                          {razorpay_order_id}
                        </div>
                      </div>
                      <button
                        type="button"
                        onClick={handleCopy}
                        className="btn btn-sm btn-outline-success d-flex align-items-center gap-1"
                        style={{ borderRadius: '6px' }}
                      >
                        {copied ? <Check size={14} /> : <Copy size={14} />}
                        <span>{copied ? 'Copied' : 'Copy'}</span>
                      </button>
                    </div>
                  )}

                  <div
                    className="p-3 mb-4 rounded-3 text-start"
                    style={{ background: '#f8fafc', border: '1px solid #e2e8f0', fontSize: '14px', lineHeight: '1.6' }}
                  >
                    <div className="fw-semibold text-dark mb-1">📋 Important Instructions:</div>
                    <ul className="mb-0 ps-3 text-secondary" style={{ fontSize: '13px' }}>
                      <li>Please show this Order ID at the reception desk during check-in.</li>
                      <li>Carry the original government photo ID submitted during registration.</li>
                      <li>Booking details have been recorded with temple accommodation management.</li>
                      <li>
                        <strong className="text-dark">Security Notice:</strong> This invitation link has now been completed and deactivated.
                      </li>
                    </ul>
                  </div>

                  {isDone && (
                    <div className="alert alert-success text-center py-2 mb-3" style={{ fontSize: '14px' }}>
                      ✓ Thank you! You may now safely close this browser tab.
                    </div>
                  )}

                  <div className="d-flex align-items-center justify-content-center">
                    <button
                      type="button"
                      className="btn btn-success d-flex align-items-center justify-content-center px-5 py-2"
                      onClick={handleDone}
                      style={{ borderRadius: '8px', fontWeight: '600', minWidth: '140px' }}
                    >
                      Done
                    </button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
